import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  HashRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';

import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import { Chiropraxie } from './pages/Chiropraxie';
import { EfficaciteetSoins } from './pages/EfficaciteetSoins';
import { FormationChiropracteur } from './pages/FormationChiropracteur.js';
import { ConsultationQui } from './pages/ConsultationQui';
import { ConsultationPourquoi } from './pages/ConsultationPourquoi';
import { Praticiens } from './pages/Praticiens';
import { Tarifs } from './pages/Tarifs';
import { DeroulementSoins } from './pages/DeroulementSoins';


function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out-cubic',
    });
  }, []);

  useDocTitle("Osmose Chiropratique | Normandie");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Chiropraxie" element={<Chiropraxie />} />
            <Route path="/EfficaciteetSoins" element={<EfficaciteetSoins />} />
            <Route path="/FormationChiropracteur" element={<FormationChiropracteur />} />
            <Route path="/ConsultationQui" element={<ConsultationQui />} />
            <Route path="/ConsultationPourquoi" element={<ConsultationPourquoi />} />
            <Route path="/Praticiens" element={<Praticiens />} />
            <Route path="/Tarifs" element={<Tarifs />} />
            <Route path="/DeroulementSoins" element={<DeroulementSoins />} />
            <Route path="/get-demo" element={<DemoProduct />} />
          </Routes>
        </ScrollToTop>
        <BackToTop />
      </Router>
    </>
  );
}


export default App;
